// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__9R4ky","aboutApp":"styles_aboutApp__sBQpb"};